module.exports = __webpack_public_path__ + "product/icon-checkmark-6af26e995790b4e91eda3e2ed6b8e4fc.svg";